// extracted by mini-css-extract-plugin
export default {"branchesContainer":"companyPanel_branchesContainer__zUW6e","link":"companyPanel_link__Y72po","editableField":"companyPanel_editableField__TcE+p"};